import storage from 'store2';

import { SET_FRIENDS_AND_FAMILY_STATE } from './actions';
import { PROP_FRIENDS_AND_FAMILY } from './constants';
import { friendsAndFamilyMemberSelector } from './selectors';

function persistFriendsAndFamilyToLocalStorage(newState) {
	if (newState) {
		storage.local.set(PROP_FRIENDS_AND_FAMILY, newState);
	} else {
		storage.local.remove(PROP_FRIENDS_AND_FAMILY);
	}
}

function miscMiddleware(store) {
	return (next) => (action) => {
		const result = next(action);

		// eslint-disable-next-line default-case,sonarjs/no-small-switch
		switch (action.type) {
			case SET_FRIENDS_AND_FAMILY_STATE:
				// read from state is safer since action might contain `toggle` token
				persistFriendsAndFamilyToLocalStorage(friendsAndFamilyMemberSelector(store.getState()));
				break;
		}

		return result;
	};
}

export default miscMiddleware;
